import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import apiAlerts from '../../services/api/apiAlerts';

const AlertsWidget = ({ sectionid }) => {
  const [alerts, setAlerts] = useState(null);

  useEffect(() => {
    if (sectionid) {
      apiAlerts
        .getAlerts(sectionid)
        .then(data => setAlerts(data))
        .catch(() => setAlerts(null));
    }
  }, [sectionid]);

  const animationAlerts = useCallback(() => {
    const time = 5000;
    const numAlerts = document.getElementsByClassName('headerAlert_item')
      .length;
    const header = document.getElementById('HeaderAlert');
    const el = header
      ? header.getElementsByClassName('headerAlert_item')
      : null;

    let countAlerts = 0;

    if (numAlerts > 1) {
      setInterval(() => {
        countAlerts += 1;

        el[countAlerts - 1].classList.remove('active');

        if (numAlerts === countAlerts) {
          countAlerts = 0;
          el[0].classList.add('active');
        } else {
          el[countAlerts].classList.add('active');
        }
      }, time);
    } else if (numAlerts === 1) {
      el[0].classList.add('active');
    }
    return false;
  }, []);

  const controlClass = useCallback(() => {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('withAlert--dark');
    body.classList.remove('withAlert--light');
    const light =
      !!document.getElementsByClassName('headerSimple').length ||
      !!document.getElementsByClassName('programHeader-container').length ||
      !!document.getElementsByClassName('article-special--bg-bgLight').length ||
      !!document.getElementsByClassName('article-special--noBg').length;
    const dark =
      !!document.getElementsByClassName('programsCarousel').length ||
      !!document.getElementsByClassName('directHeader').length ||
      !!document.getElementsByClassName('article-special--bg-dark').length ||
      window.location.href.includes('ondacero.es/podcast/') ||
      !!document.querySelectorAll('[data-type=header-live]').length;
    if (alerts) {
      body.classList.add('withAlert');
      if (light) {
        body.classList.add('withAlert--light');
        body.classList.remove('withAlert--dark');
      }
      if (dark) {
        body.classList.add('withAlert--dark');
        body.classList.remove('withAlert--light');
      }
    }
  }, [alerts]);

  useEffect(() => {
    animationAlerts();
    controlClass();
  }, [alerts, animationAlerts, controlClass]);

  return (
    <div
      className="headerAlert-container"
      dangerouslySetInnerHTML={{
        __html: !alerts ? '' : alerts
      }}
    />
  );
};

export default AlertsWidget;

AlertsWidget.propTypes = {
  sectionid: PropTypes.string.isRequired
};
